import { createApiClient } from "./client";

const client = createApiClient();

export const exams = {
  getAssesmentsv2: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/candidates/${id}/exams?per_page=${perPage}&page=${currentPage}${type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),
  getAssesmentsv3: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/participants/${id}/assessments/exam?per_page=${perPage}&page=${currentPage}${type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),
  ///participants/:userId/assessments/:assessmentId/user-exams/:userExamId/exams/:examId/initiate-questions/:category?attempt=1&showOnlyQuestions
  getExamQuestionsv2: ({ userId, assessmentId, userExamId, examId, language, showOnlyQuestions, switchQuestion, level, number_of_attempts, ignoreCache = false }) =>
    client
      .get(`/participants/${userId}/assessments/${assessmentId}/user-exams/${userExamId}/exams/${examId}/initiate-questions/exam?showOnlyQuestions=${showOnlyQuestions}&language=${language}${switchQuestion ? `&switchQuestions=${switchQuestion}` : ""
        }${level ? `&level=${level}` : ""}${number_of_attempts ? `&attempt=${number_of_attempts}` : ""}${'' /*ignoreCache ? `&ignoreCache=${ignoreCache}` : ""*/
        }`)
      .then(({ data }) => data),

  getExamQuestionsv1: ({ userId, examId, userExamId, language, showOnlyQuestions, switchQuestion, level, number_of_attempts }) =>
    client
      .get(`/candidates/${userId}/exams/${examId}/questions/${userExamId}?showOnlyQuestions=${showOnlyQuestions}&language=${language}${switchQuestion ? `&switchQuestions=${switchQuestion}` : ""
        }${level ? `&level=${level}` : ""}${number_of_attempts ? `&attempt=${number_of_attempts}` : ""}`)
      .then(({ data }) => data),
  /* UPDATE ANSWERS */
  //participants/:user_id/assessments/:assessment_id/questions/:user_exam_id/save-answers
  updateAnswersv2: ({ data, userId, assessmentId, userExamId }) =>
    client
      .post(
        `/participants/${userId}/assessments/${assessmentId}/questions/${userExamId}/save-answers`,
        data
      )
      .then(({ data }) => data),
  // updateAnswersv2: ({ data, userId, examId, userExamId }) =>
  //   client
  //     .post(
  //       `/candidates/${userId}/exams/${examId}/questions/${userExamId}/save-answers`,
  //       data
  //     )
  //     .then(({ data }) => data),

  initiateAssessment: (payload) =>
    client
      .post(
        `/participants/initiate-assessment`,
        payload
      )
      .then(({ data }) => data),

  autoOnboardUser: (payload) =>
    client
      .post(`/participants/auto-onboard-user`, payload)
      .then(({ data }) => data),

  gradeAssessmentv2: ({ userId, examId, assessmentId, userExamId, attempt }) =>
    client
      .post(
        `/participants/${userId}/assessments/${assessmentId}/user-exams/${userExamId}/exams/${examId}/submit-assessment/exam`, { attempt }
      )
      .then(({ data }) => data),

  gradeAssessmentv1: ({ userId, examId, userExamId, attempt }) =>
    client
      .post(
        `/candidates/${userId}/exams/${examId}/questions/${userExamId}/submit-exam`, { attempt }
      )
      .then(({ data }) => data),

  getExamsHistoryv2: ({ id, currentPage, perPage, search }) =>
    client
      .get(
        `/participants/${id}/pipelines/history?per_page=${perPage}&page=${currentPage}${search ? `&search=${search}` : ""
        }`
      )
      .then(({ data }) => data),

  getBookingsv2: (userId, examId) =>
    client
      .get(`/candidates/${userId}/exams/${examId}/bookings`)
      .then(({ data }) => data),

  getBookingsv3: (userId, pipelineId,) =>
    client
      .get(`/participants/${userId}/pipelines/${pipelineId}/exam`)
      .then(({ data }) => data),

  getBranding: () =>
    client
      .get(`/clients/6b9d247d-78ba-417f-9fcf-ae8fc3e574d9`)
      .then(({ data }) => data),

  createBookingv2: ({ userId, examId, payload }) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/bookings`, { ...payload })
      .then(({ data }) => data),

  createBookingv3: ({ userId, pipelineId, groupId, payload }) =>
    client
      .post(`participants/${userId}/pipelines/${pipelineId}/bookings/${groupId}`, payload)
      .then(({ data }) => data),

  logAssessment: ({ payload }) =>
    client
      .post(`/assessments/log`,
        payload
      )
      .then(({ data }) => data),
  //
  unlockAssessmentv2: (userId, examId, payload) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/bookings/activate`, {
        ...payload,
      })
      .then(({ data }) => data),

  loginBasedLinkExam: (payload) =>
    client.post(`/auth/login/exam`, { ...payload }).then(({ data }) => data),
  // getExamResults: ({ userId, examId, userExamId }) =>
  //   client
  //     .get(`/candidates/${userId}/exams/${examId}/results/${userExamId}`)
  //     .then(({ data }) => data),
  getExamResults: ({ userId, assessmentId, userExamId }) =>
    client
      .get(`/participants/${userId}/assessments/${assessmentId}/results/${userExamId}`)
      .then(({ data }) => data),
  retakeExam: ({ userId, userExamId, assessmentId }) =>
    client
      .get(`/participants/${userId}/exams/${userExamId}/assessments/${assessmentId}/retry-attempt`)
      .then(({ data }) => data),

  getProctoringStatus: ({ userId, assessmentId, userExamId }) =>
    client
      .get(`/participants/${userId}/assessments/${assessmentId}/questions/${userExamId}/proctoring-status`)
      .then(({ data }) => data),

  logViolation: ({ userExamId, payload }) =>
    client
      .post(`/log-violation/${userExamId}`, payload)
      .then(({ data }) => data),

};
